import React from "react";
import { SITE_URL } from "utils/constants";

const MetaTags = ({ seo, path = "" }) => {
	const { title = "", description, image, noIndex } = seo || {};

	const cleanUrl = (SITE_URL || "").replace("www.", "");

	let canonicalUrl = cleanUrl + path;

	// Check if the path is PDP
	const match = path.match(/\/products\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]+/);

	// If there's a match, remove the variant from the canonical URL
	if (match)
		canonicalUrl = cleanUrl + path.slice(0, path.lastIndexOf("/"));

	return (
		<>
			<html rel="alternate" lang="en" />
			<title>{`${title} - MOD LIGHTING`}</title>
			<link rel="canonical" href={canonicalUrl} />
			<meta property="og:site_name" content="MOD LIGHTING"></meta>
			<meta property="og:url" content={`${cleanUrl}${path}`}></meta>
			<meta property="og:title" content={title}></meta>
			<meta property="og:type" content="website"></meta>
			{description && <meta name="description" property="og:description" content={description}></meta>}
			{image && <meta property="og:image" content={image}></meta>}
			{/* TODO: Remove this line when we go fully live to allow search engines to index the site */}
			{noIndex && <meta name="robots" content="noindex" />}

			{/* Twitter Card*/}
			<meta name="twitter:card" content="summary_large_image"></meta>
			{title && <meta name="twitter:title" content={title}></meta>}
			{description && <meta name="twitter:description" content={description}></meta>}
			{image && <meta name="twitter:image" content={image}></meta>}
			<meta property="twitter:domain" content={SITE_URL}></meta>
			<meta property="twitter:url" content={SITE_URL}></meta>
		</>
	);
};

export default MetaTags;
